import { defineStore } from 'pinia';

type FormMode = 'support' | 'compensation' | '';

export const useHelpStore = defineStore('help', {
  state: () => ({
    showHelpDrawer: false,
    loading: false,
    formMode: '',
  }),
  actions: {
    toggleDrawer() {
      this.showHelpDrawer = !this.showHelpDrawer;
    },
    openDrawer() {
      this.showHelpDrawer = true;
    },
    closeDrawer() {
      this.showHelpDrawer = false;
    },
    changeFormMode(formMode: FormMode) {
      this.formMode = formMode;
    },
  },
});
